<template>
    <company-details
        :company="company"
        :remote_measures="remote_measures"
        :is_following="is_following"
        :origin="origin"
        v-on:backToHome="backToHome"
    ></company-details>
</template>

<script>
    export default {
        props: ['company', 'remote_measures', 'is_following', 'origin'],

        methods: {
            backToHome() {
                this.$emit('backToHome');
            }
        }
    }
</script>

<style scoped>

</style>
